jQuery(function () {
  const domReady = (cb) => {
    if (typeof wp !== "undefined" && wp.domReady) wp.domReady(cb);
    else cb();
  };

  const once = (eventName, cb) => {
    document.addEventListener(eventName, cb, { once: true });
  };

  const whenGsapReady = (cb) => {
    if (window.gsap) return cb();
    once("longevity:gsap-ready", cb);
  };

  const whenScrollReady = (cb) => {
    let ran = false;
    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };
    once("longevity:scroll-ready", runOnce);
    setTimeout(runOnce, 0);
  };

  domReady(() => {
    whenGsapReady(() => {
      whenScrollReady(() => {
        initFaqAccordion();
        initFaqReveal();
      });
    });
  });

  function initFaqAccordion() {
    const blocks = document.querySelectorAll(".js-faq");
    if (!blocks.length) return;

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    blocks.forEach((block) => {
      if (block.dataset.faqAccordionInit === "1") return;
      block.dataset.faqAccordionInit = "1";

      const openFirst = block.getAttribute("data-open-first") === "1";
      const items = block.querySelectorAll(".faq__item");

      items.forEach((item, index) => {
        const trigger = item.querySelector(".faq__trigger");
        const panel = item.querySelector(".faq__panel");
        if (!trigger || !panel) return;

        const setOpen = (open) => {
          item.classList.toggle("is-open", open);
          trigger.setAttribute("aria-expanded", open ? "true" : "false");
          panel.setAttribute("aria-hidden", open ? "false" : "true");
        };

        if (openFirst && index === 0) {
          setOpen(true);
        } else if (!item.classList.contains("is-open")) {
          setOpen(false);
        } else {
          setOpen(true);
        }

        trigger.addEventListener("click", () => {
          const willOpen = !item.classList.contains("is-open");
          if (willOpen) {
            items.forEach((other) => {
              if (other === item) return;
              const t = other.querySelector(".faq__trigger");
              const p = other.querySelector(".faq__panel");
              other.classList.remove("is-open");
              if (t) t.setAttribute("aria-expanded", "false");
              if (p) p.setAttribute("aria-hidden", "true");
            });
          }
          setOpen(willOpen);
        });
      });

      if (reduceMotion) {
        block.querySelectorAll(".faq__panel").forEach((p) => {
          p.style.transition = "none";
        });
      }
    });
  }

  function initFaqReveal() {
    const blocks = document.querySelectorAll(".js-faq");
    if (!blocks.length) return;

    if (document.body.classList.contains("block-editor-page")) {
      blocks.forEach((block) => {
        block.querySelectorAll(".js-faq-item").forEach((el) => {
          el.style.opacity = "1";
          el.style.visibility = "visible";
        });
      });
      return;
    }

    const gsap = window.gsap;
    if (!gsap) return;

    const ScrollTrigger =
      window.ScrollTrigger ||
      (gsap.core && gsap.core.globals && gsap.core.globals().ScrollTrigger) ||
      null;

    if (ScrollTrigger && gsap.registerPlugin) {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (e) {}
    }

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    blocks.forEach((block) => {
      if (block.dataset.faqRevealInit === "1") return;
      block.dataset.faqRevealInit = "1";

      const items = block.querySelectorAll(".js-faq-item");
      if (!items.length) return;

      if (reduceMotion) {
        gsap.set(items, { autoAlpha: 1, y: 0, clearProps: "transform" });
        return;
      }

      gsap.set(items, { autoAlpha: 0, y: 16 });

      const vars = {
        autoAlpha: 1,
        y: 0,
        duration: 0.85,
        ease: "power3.out",
        stagger: 0.06,
        clearProps: "transform",
      };

      if (ScrollTrigger) {
        vars.scrollTrigger = {
          trigger: block,
          start: "top 78%",
          once: true,
          invalidateOnRefresh: true,
        };
      }

      gsap.to(items, vars);
    });
  }
});
